<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Order-Menu">
    <mat-icon *ngIf="!showSpinner" style="transform: scale(2);">more_horiz</mat-icon>
    <mat-spinner *ngIf="showSpinner" [diameter]="40" ></mat-spinner>
</button>

<mat-menu #menu="matMenu" xPosition="before">
    <button *ngFor="let config of navigationEntries" (click)="navigate(config.route)" mat-menu-item>
        <mat-icon>{{config.icon}}</mat-icon>
        <span>{{config.name}}</span>
    </button>
    <button (click)="archiveOrder()" mat-menu-item>
      <ng-container *ngIf="order.archived">
        <mat-icon>upload</mat-icon>
        <span>Wiederherstellen</span>
      </ng-container>
      <ng-container *ngIf="!order.archived">
        <mat-icon>archive</mat-icon>
        <span>Archivieren</span>
      </ng-container>
    </button>
    <button mat-menu-item (click)="openPermissions()">
        <mat-icon>folder_shared</mat-icon>
        <span>Berechtigungen</span>
    </button>
    <button mat-menu-item (click)="openUserGroupManagement()">
        <mat-icon>group</mat-icon>
        <span>Nutzergruppen-Verwaltung</span>
    </button>
</mat-menu>
